import React, { useEffect } from 'react';
import './Components.css';
import logo from '../assets/logo.png';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Avatar, Button } from 'antd';
import { UserInfo } from './UserInfo';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';

const AppLayout = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  const handleSignOut = (event: any) => {
    console.log(event);
    console.log('Logging out...');
    localStorage.removeItem('accessToken');
    instance.logoutRedirect();
  };

  const handleLogin = () => {
    instance.loginRedirect({
      scopes: ['profile', 'openid', 'email', 'User.Read'],
    });
  };

  useEffect(() => {
    const activeAccount = instance.getActiveAccount();
    if (activeAccount) {
      instance
        .acquireTokenSilent({
          scopes: ['profile', 'openid', 'email', 'User.Read'],
          account: activeAccount,
        })
        .then((response) => {
          const expirationTime = response.expiresOn.getTime();
          const currentTime = new Date().getTime();
          const timeUntilExpiration = expirationTime - currentTime;
          if (timeUntilExpiration > 0) {
            const timeoutId = setTimeout(() => {
              instance.logoutRedirect();
            }, timeUntilExpiration);

            localStorage.clear();
            return () => clearTimeout(timeoutId);
          }
        })
        .catch((error) => {
          console.error('Token acquisition failed: ', error);
          instance.logoutRedirect();
        });
    }
  }, [instance]);

  return (
    <>
      <Layout.Header className="layout-header">
        <div className="logo-container">
          <Link to={'/hearing/'}>
            <img src={logo} alt="AER Logo" style={{ height: '75px', marginTop: '10px' }} />
          </Link>
          <div className="separator"></div>
          <div className="header">
            <span className="header-title">Welcome to the Hearings – Public Record System</span>
            <span className="header-subtitle">
              The AER maintains a public record for all hearings. This system enables the public to
              access the documents associated with a hearing. All of these documents are called
              Exhibits. You can use this system to find a proceeding, find Exhibits, find key dates
              associated with a proceeding, including the hearing date, the status of a proceeding,
              or other information you may be interested in. Please reach out
              to&nbsp;
              <a href="mailto:Hearing.Services@aer.ca">Hearing.Services@aer.ca</a> if you require
              assistance.
            </span>
            <span className="header-subtitle">
              <b>
                Due to migration from an archived system to this new system, some information fields
                may be incorrect or missing. While we work to correct this information, please rely
                on the Exhibits to find the most accurate information.
              </b>
            </span>
          </div>
          <div className="user-info-container">
            {isAuthenticated ? (
              <div className="user-info">
                <Avatar icon={<UserOutlined />}  className="avatar" />
                <UserInfo />
                <Button type="dashed" icon={<LogoutOutlined />} onClick={handleSignOut}   className="logout-button" />
              </div>
            ) : (
              <Button type="default" onClick={handleLogin} className="login-button">
                Administrator Login
              </Button>
            )}
          </div>
        </div>
      </Layout.Header>
    </>
  );
};

export default AppLayout;
